/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./aiSpeechSetting.vue?vue&type=template&id=49f07a4e&scoped=true&"
import script from "./aiSpeechSetting.vue?vue&type=script&lang=js&"
export * from "./aiSpeechSetting.vue?vue&type=script&lang=js&"
import style0 from "./aiSpeechSetting.vue?vue&type=style&index=0&id=49f07a4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f07a4e",
  null
  
)

export default component.exports